import { Alert, AlertTitle, CircularProgress } from "@mui/material";
import useSWR from "swr";
import { useOutletContext } from "react-router-dom";

export default function IntakeRequirementsAlert({ intakeId }) {
  const { api } = useOutletContext();
  const { isLoading, error, data } = useSWR(`/intake/${intakeId}`, () =>
    api.getIntake(intakeId),
  );

  if (error) {
    return <Alert severity="error">{error.message}</Alert>;
  }

  if (isLoading) {
    return <CircularProgress />;
  }

  if (!data) return null;

  if (data.status === "qualified") return null;

  if (data.reqs.length === 0) return null;

  const serviceChannel = data.sc_override ?? data.computed_service_channel;
  if (serviceChannel === "drop-ship") return null;

  return (
    <Alert severity="error">
      <AlertTitle>Missing Data</AlertTitle>
      <ul style={{ paddingInlineStart: "20px" }}>
        {data.reqs.map((r) => (
          <li key={r}>{r}</li>
        ))}
      </ul>
    </Alert>
  );
}
